import React, { useState, useEffect } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'

const TabAgenteOptions = () => {

    const [labelPosition, setLabelPosition] = useState('');
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
      !location.hash ? navigate(`/#solicitudes`) :
      chooseLabelPosition(!location.hash ? '#solicitudes' : location.hash);
    }, [location])
    

    const chooseLabelPosition = (state) => {
      setLabelPosition(state);
    }
  
  return (
    <>
      <ul className="nav">
        <li className="nav-item">
          <Link
            to={`/`}
            className="nav-link"
          >
            Solicitudes
            {labelPosition === "#solicitudes" && (
              <hr style={{ border: " 1px solid blue" }} />
            )}
          </Link>
        </li>
        <li className="nav-item">
          <Link
            to={`/#usuarios`}
            className="nav-link"
          >
            Usuarios
            {labelPosition === "#usuarios" && (
              <hr style={{ border: " 1px solid blue" }} />
            )}
          </Link>
        </li>
      </ul>
      <hr className="nav_linea_selector" />
    </>
  );
};

export default TabAgenteOptions;
